import Vue from 'vue';
import Vuetify from 'vuetify';

Vue.use(Vuetify)

// https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
export default new Vuetify({
})
